import { gsap } from 'gsap';

export default function initAccordion() {
  const openedClass = 'opened';
  const slideClass = 'js-accordion-slide';

  document.querySelectorAll('.js-accordion').forEach((holder) => {
    let prevItem = null;
    const accordionItems = holder.querySelectorAll('li');
    let interval;

    accordionItems.forEach((item) => {
      const opener = item.querySelector('.js-accordion-opener');
      const content = item.querySelector(`.${slideClass}`);

      const tl = gsap.timeline({ paused: true });

      const heading = item.querySelector('.wysiwyg');

      if (heading) {
        const headline = heading.querySelector('h4');
        const title = headline && headline.textContent;
        if (headline) {
          headline.textContent = '';
        }
        const text = heading.querySelectorAll('p, ul');
        const btns = heading.querySelectorAll('div.flex:has(.btn)');

        if (title) {
          title.split('').forEach((char) => {
            const span = document.createElement('span');
            span.textContent = char;
            if (char === ' ') {
              span.classList.add('space');
            }
            headline.appendChild(span);
          });
          tl.from(headline.querySelectorAll('span'), {
            xPercent: -10,
            opacity: 0,
            duration: 0.1,
            stagger: 0.02,
            ease: 'power2.out',
          });
        }

        if (text.length) {
          tl.from(
            text,
            {
              opacity: 0,
              duration: 0.6,
              stagger: 0.1,
              ease: 'power2.out',
            },
            '>'
          );
        }
        if (btns.length) {
          tl.from(
            btns,
            {
              opacity: 0,
              duration: 0.6,
              ease: 'power2.out',
            },
            '>'
          );
        }
      }

      if (item.classList.contains(openedClass)) {
        heading.style.opacity = '1';
        tl.restart();
        prevItem = item;
        if (content) {
          content.classList.add('grid-rows-[1fr]');
          content.classList.remove('grid-rows-[0fr]');
        }
        if (opener) opener.setAttribute('aria-expanded', true);
      } else if (content) {
        content.classList.add('grid-rows-[0fr]');
        content.classList.remove('grid-rows-[1fr]');
        if (opener) opener.setAttribute('aria-expanded', false);
      }

      if (opener) {
        opener.addEventListener('click', (e) => {
          e.preventDefault();
          const isOpened = item.classList.toggle(openedClass);
          opener.setAttribute('aria-expanded', isOpened);
          if (content) {
            content.classList.toggle('grid-rows-[1fr]', isOpened);
            content.classList.toggle('grid-rows-[0fr]', !isOpened);
          }
          if (isOpened) {
            clearTimeout(interval);
            heading.style.opacity = '0';
            interval = setTimeout(() => {
              heading.style.opacity = '1';
              tl.restart();
              const offset = window.innerWidth > 1140 ? 20 : 116;
              const rect = item.getBoundingClientRect();
              const scrollPosition = window.scrollY + rect.top - offset;

              window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth',
              });
            }, 800);
          }

          setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
          }, 800);

          if (prevItem && prevItem !== item) {
            prevItem.classList.remove(openedClass);
            const prevOpener = prevItem.querySelector('.js-accordion-opener');
            if (prevOpener) prevOpener.setAttribute('aria-expanded', false);

            const prevContent = prevItem.querySelector(`.${slideClass}`);
            if (prevContent) {
              prevContent.classList.add('grid-rows-[0fr]');
              prevContent.classList.remove('grid-rows-[1fr]');
            }
          }

          prevItem = isOpened ? item : null;
        });
      }
    });
  });
}
